/* eslint-disable react/jsx-boolean-value */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import FormLabel from 'components/pages/ResourceSetting/Widgets/FormLabel';
import FormFileDrop from 'components/pages/ResourceSetting/Widgets/FormFileDrop';
import Styles from './index.module.css';

export default function MediaField({
  value,
  onChange,
  ...props
}) {
  const description = (
    <>
      圖片像素限制1080x1080~2400x2400，檔案大小限制5MB
      <br />
      影片尺寸限制16:9或1:1，檔案大小限制100MB
    </>
  );
  return (
    <div className={Styles.mainContainer} {...props}>
      <FormLabel
        title="上傳廣告素材"
        description={description}
        required={true}
      />
      <div className={Styles.fileDropContainer}>
        <FormFileDrop
          onSelectFile={(files) => onChange(files[0])}
          selectedFilename={value}
          title="圖片/影片"
          description="請拖曳檔案或點選上傳框上傳檔案"
        />
      </div>
    </div>
  );
}

MediaField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
};

MediaField.defaultProps = {
  value: '',
  onChange: () => { },
};
